import { render, staticRenderFns } from "./AccessRecipient.vue?vue&type=template&id=03c3a6ac&"
import script from "./AccessRecipient.vue?vue&type=script&lang=ts&"
export * from "./AccessRecipient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports